import React, {useEffect, useState} from "react";
import associateServices from "../../../services";
import Loading from "../../../components/loading";
import {useTranslation} from "react-i18next";
import moment from "moment/moment";
import Big from "big.js";
import InstrumentIcon from "../../../components/instrument-icon";
import TableFooter from "../../../components/table-footer/TableFooter";
import NoData from "../../../components/no-data";
import {useSearchParams} from "react-router-dom";
import {Tooltip} from "react-tooltip";
import {useSelector} from "react-redux";
import StringHelper from "../../../helpers/string-helper";


const BetsTrade = (props) => {
    const {data} = props
    const {t} = useTranslation()
    const [searchParams, setSearchParams] = useSearchParams()
    const {
        selectedFiat,
        fiatRates
    } = useSelector(state => state.authenticationReducer)
    const {
        symbols
    } = useSelector(state => state.globalReducer)

    const handleBetDetail = bet => {

        searchParams.set('modal', 'bet')
        searchParams.set('reference', bet.id)
        setSearchParams(searchParams)
    }


    return (
        <table className="xtable xtable--small">
            <thead>
            <tr>
                <th>#</th>
                <th>{t('transactions.bets.table.game')}</th>
                <th>{t('transactions.bets.table.time')}</th>
                <th className="text-right">{t('transactions.bets.table.bet')}</th>
                <th className="text-right">{t('transactions.bets.table.status')}</th>
                <th className="text-right">{t('transactions.bets.table.multiplier')}</th>
                <th>{t('transactions.bets.table.profit')}</th>

            </tr>
            </thead>
            <tbody>

            {
                data?.map(debit => (
                    <tr key={debit?.id}>
                        <td className="cursor-pointer">
                            <div
                                onClick={e => handleBetDetail(debit)}
                                className="xtable__text xtable__text--text-secondary">
                                #{debit?.id}
                            </div>
                        </td>
                        <td>
                            <div className="xtable__text xtable__text--green">
                                {StringHelper.capitalizeFirstLetter(debit?.game)}
                            </div>
                        </td>
                        <td>
                            <div className="xtable__text">

                                                    <span className="xtable__text-date">
                                                                        {moment.unix(debit?.timestamp || 0).format('MMMM Do')}

                                                        <small>
                                                                        {moment.unix(debit?.timestamp || 0).format('h:mm:ss a')}
                                                                    </small>
                                                                    </span>

                            </div>
                        </td>
                        <td className="text-right">
                            <div className="xtable__coin gap-1 text-secondary">
                                <span>{symbols[selectedFiat]}</span>

                                <Tooltip className="tooltip-me"
                                         anchorSelect={`#bet-amount-${debit.id}`}>
                                                                    <span className="xtable__coin gap-1">
                                                                        {Big(debit?.wallet_amount || 0).toFixed(8)}
                                                                        <InstrumentIcon code={debit?.wallet_currency}/>
                                                                    </span>
                                </Tooltip>

                                <span className="xtable__coin text-secondary"
                                      id={`bet-amount-${debit.id}`}>
                                                                        {
                                                                            selectedFiat ? Big(debit?.wallet_amount || 0).div(fiatRates[debit.wallet_currency] || 1).toFixed(8) :
                                                                                Big(debit?.wallet_amount || 0).toFixed(8)
                                                                        }
                                                                        </span>


                                <InstrumentIcon code={debit?.wallet_currency}/>


                            </div>
                        </td>

                        <td className="text-right">
                            <div className={`xtable__text xtable__text--${debit?.finished ? 'green' : 'red'}`}>
                                {debit?.finished ? t('general.closed') : t('general.open')}
                            </div>
                        </td>

                        <td className="text-right">
                            <div className="xtable__text">
                                x{parseFloat(debit?.multiplier || 0) >= 0 ? Big(debit?.multiplier || 0).toFixed(2) : Big(0).toFixed(2)}
                            </div>
                        </td>
                        <td>
                            <div
                                className={`xtable__coin ${debit?.multiplier >= 1 ? 'xtable__coin--green' : 'text-secondary'} gap-1`}>

                                <span>{symbols[selectedFiat]}</span>

                                <Tooltip className="tooltip-me"
                                         anchorSelect={`#win-amount-${debit?.id}`}>
                                                                    <span className="xtable__coin gap-1">
                                                                        {
                                                                            Big(debit?.wallet_income || 0).minus(parseFloat(debit?.multiplier) === 1 ? 0 : debit?.wallet_amount)
                                                                                .toFixed(8)
                                                                        }
                                                                        <InstrumentIcon code={debit?.wallet_currency}/>
                                                                    </span>
                                </Tooltip>

                                <span id={`win-amount-${debit?.id}`}>
                                                                {
                                                                    selectedFiat ?
                                                                        Big(debit?.wallet_income || 0).minus(parseFloat(debit?.multiplier) === 1 ? 0 : debit?.wallet_amount)
                                                                            .div(fiatRates[debit?.wallet_currency] || 1)
                                                                            .toFixed(8)
                                                                        : Big(debit?.wallet_income || 0).minus(parseFloat(debit?.multiplier) === 1 ? 0 : debit?.wallet_amount).toFixed(8)

                                                                }
                                                                </span>

                                <InstrumentIcon code={debit?.wallet_currency}/>
                            </div>
                        </td>
                    </tr>
                ))
            }

            </tbody>
        </table>
    )
}

export default BetsTrade
